import { useContext } from 'react';

import { useFeatureValue } from '@/hooks/useFeatureValue';
import { ChewyPortalContext } from '@/providers/ChewyPortalProvider';
import { useMarket } from '@/providers/MarketProvider';
import { FeatureConfigKeys } from '@/utils/athena-feature-config';

export const useContentMfeToggle = () => {
  const isChewyPortalEnabled = useContext(ChewyPortalContext) ?? false;
  const { isUSMarket } = useMarket();
  const isContentMfeEnabled = useFeatureValue(FeatureConfigKeys.CONTENT_MFE_ENABLED, isUSMarket);
  return isContentMfeEnabled && isChewyPortalEnabled;
};
